import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";

import Container from "@mui/material/Container";
import Card from "@mui/material/Card";
import Grid from "@mui/material/Grid";

import PageLayout from "examples/LayoutContainers/PageLayout";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDButton from "components/MDButton";

export default function RegisterCancel() {
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <PageLayout>
      <MDBox minHeight="60vh" display="flex" alignItems="center" py={6}>
        <Container>
          <Grid container justifyContent="center">
            <Grid item xs={12} sm={10} md={7} lg={6}>
              <Card>
                <MDBox p={4} textAlign="center">
                  <MDTypography variant="h4" fontWeight="bold" mb={1}>
                    {t("register.cancel.title")}
                  </MDTypography>

                  <MDTypography variant="button" color="text" mb={3} display="block">
                    {t("register.cancel.message")}
                  </MDTypography>

                  <MDBox display="flex" gap={1.5} justifyContent="center" flexWrap="wrap">
                    <MDButton variant="gradient" color="info" onClick={() => navigate("/authentication/register")}>
                      {t("register.cancel.tryAgain")}
                    </MDButton>

                    <MDButton variant="outlined" color="dark" onClick={() => navigate("/")}>
                      {t("register.cancel.home")}
                    </MDButton>
                  </MDBox>
                </MDBox>
              </Card>
            </Grid>
          </Grid>
        </Container>
      </MDBox>
    </PageLayout>
  );
}
